export default __webpack_public_path__ + "static/media/radiant-bright-orange-pink.558d5147.jpg";